import { routes } from './routes'
import { vsName as userProfileModuleName } from '../application/userProfileModule'
import { progressiveDefinitionMachineViewComponentOptions, vsComponentName as progressiveDefinitionMachineViewComponentName } from './views/definitions/detail/machines/component'
import { progressiveDefinitionsDetailMachineEditViewComponentOptions, vsComponentName as progressiveDefinitionsDetailMachineEditViewComponentName } from './views/definitions/detail/machines/edit'
import { vsServiceName as configServiceName, ProgressiveModuleConfigurationServiceProvider} from "./progressiveModuleConfigurationService"
import { vsModuleName as chartModuleName } from "../ui/chart"

export const vsModuleName = 'SlotTrak.Machines.Progressives'

var mod = angular.module(vsModuleName, ['records', userProfileModuleName, chartModuleName])

mod
  .config(routes)
  .component(progressiveDefinitionMachineViewComponentName, progressiveDefinitionMachineViewComponentOptions)
  .component(progressiveDefinitionsDetailMachineEditViewComponentName, progressiveDefinitionsDetailMachineEditViewComponentOptions)
  .provider(configServiceName, ProgressiveModuleConfigurationServiceProvider)

export default mod.name